export default {
    home_page_title: "Informazioni account",
    security_page_title: "Centro sicurezza",
    security_setting_page_title: "Centro sicurezza",
    security_phone_label: "Mobile",
    security_email_label: "Email",
    security_question_label: "Domande di sicurezza",
    security_unset_text: "Non impostato",
    security_setted_text: "Impostato",
    security_question_options: [
        "Quale è il nome di tua madre?",
        "Quale è la data di nascita del tuo/a partner?",
        "Quale è il nome di tuo padre?",
        "Quale è il tuo numero identificativo da studente/impiegato?",
        "Chi era il tuo migliore amico d&#39infanzia?",
        "Chi è la persona che ha avuto la più grande influenza su di te?"
    ],
    password_lost_page_title: "Password dimenticata",
    password_reset_page_title: "Reimposta password",
    password_lost_account_placeholder:
        "Inserire l&#39account di cui si è dimenticata la password",
    empty_lost_account_tips: "Il nome utente non può essere vuoto",
    iscorrect_lost_account_tips: "L\\utente non esiste",
    password_reset_new_placeholder: "Nuova password",
    password_reset_confirm_placeholder: "Conferma nuova password",
    password_verify_page_title: "Verifica identità",
    phone_verify_page_title: "Verifica identità",
    email_verify_page_title: "Verifica identità",
    question_verify_page_title: "Verifica identità",
    phone_reset_page_title: "Mobile",
    email_reset_page_title: "Email",
    question_reset_page_title: "Domande di sicurezza",
    phone_binding_text: "Il numero di cellulare collegato è",
    email_binding_text: "L&#39indirizzo email collegato è",
    verification_code_text: "Codice di verifica",
    resend_text: "Nuovo invio",
    empty_phone_number_tips: "Inserire numero cellulare",
    iscorrect_phone_number_tips:
        "Inserire un numero di cellulare con formato corretto",
    empty_verification_code_tips: "Inserisci codice di verifica",
    iscorrect_verification_code_tips: "Errore autenticazione",
    password_placeholder: "Password",
    empty_password_tips: "Inserisci password",
    iscorrect_password_tips: "Errore password",
    mismatched_rule_password_tips:
        "La password non può contenere &, #, o spazi vuoti",
    different_confirm_password_tips: "Password non uguali",
    empty_email_tips: "Si prega di inserire l&#39indirizzo email",
    iscorrect_email_tips: "Errore indirizzo email",
    answer_placeholder: "Risposta",
    empty_question_tips: "Selezionare domande",
    empty_answer_tips: "Inserire risposta,",
    iscorrect_answer_tips: "Risposta errata",
    next_step_text: "Avanti",
    submit_text: "Invia",
    submit_success_tips: "Impostazione effettuata",
    submit_error_tips: "Operazione non riuscita, riprova",
    get_data_fail_tips: "Anomalia nel network, si prega di riprovare",
    use_other_verification_type_text: "Altri metodi di verifica",
    custom_support_notice:
        "Sistemi di sicurezza non impostati per questo account. Puoi aprire il link seguente dal tuo PC per inviare una richiesta" +
        process.env.VUE_APP_ORIGIN_PROFILE
};
